// One line saying what a playlist row's call sets ("B♭ · ♩=200 · Bossa Nova ·
// ×3"), for the playlist page, the playlist popover and Tune details. Pure.

import { describeBandPreset } from '@/music/style';
import type { PlaylistCall } from '@/storage/playlists';

export function playlistCallSummary(call: PlaylistCall | undefined): string {
  if (!call) return '';
  const parts: string[] = [];
  if (call.key) parts.push(call.key.replace('b', '♭').replace('#', '♯'));
  if (call.tempo) parts.push(`♩=${call.tempo}`);
  if (call.band && Object.keys(call.band).length) {
    parts.push(describeBandPreset(call.band)?.label ?? 'Custom');
  }
  if (call.repeats && call.repeats > 1) parts.push(`×${call.repeats}`);
  if (call.policy === 'head-solos-head') parts.push('Head, solos, out');
  const ending = call.ending;
  if (ending) {
    if (ending.ritardandoBars > 0) parts.push('Slow down');
    if (ending.tagBars > 0) parts.push('Tag');
    if (ending.holdLast) parts.push('Hold');
    if (ending.resolve && ending.resolve !== 'off') parts.push('Resolve');
  }
  return parts.join(' · ');
}
